import {
  LearnersStudentPreferencesPreferenceIssuesTrait,
  LearnersStudentPreferencesSubjectPreferenceSet,
  LearnersStudentPreferencesSubjectPreferenceSetAllTrait,
} from "@/types/serializers"
import { Brand, identity } from "ts-brand"

export type SubjectId = Brand<number, "SubjectId">
export const SubjectId = ({ id }: { id: number }) => identity<SubjectId>(id)

export type PreferenceId = Brand<number, "PreferenceId">
export const PreferenceId = ({ id }: { id: number }) =>
  identity<PreferenceId>(id)

export type PriorityId = Brand<string, "PriorityId">
export const PriorityId = ({ id }: { id: string }) =>
  identity<PriorityId>(`${id}`)

export interface Subject {
  id: SubjectId
  code: string
  name: string
  preferenceIds: PreferenceId[]
}

export interface Priority {
  uuid: PriorityId
  preferenceId: PreferenceId | null
  priority: number
  sessions: Array<{
    day: number
    startTime: string
    duration: number
  }>
}

type Document = {
  name: string
  cycleLength: number
  timezoneId: string
  listingProfileName: string
  teacherName: string | null
  timetablePriorities: PriorityId[]
}
export type Preference = {
  id: PreferenceId
  esClassListingId: string
  esTeacherId: string | null
  rank: number
  subjectId: SubjectId
  priorities: PriorityId[]
  issues: LearnersStudentPreferencesPreferenceIssuesTrait["issues"]
} & (
  | {
      educatorName: string
      classDocument: Document
    }
  | { classDocument: null; educatorName: null }
)

export type ValidPreference = Extract<Preference, { classDocument: Document }>

export interface RouteState {
  href: string
  data: object
}

export type LearnersPreferences =
  LearnersStudentPreferencesSubjectPreferenceSetAllTrait &
    LearnersStudentPreferencesSubjectPreferenceSet

export type PreferenceError =
  | {
      kind: "conflict"
      conflicts: Array<[SubjectId, [PriorityId, PreferenceId][]]>
    }
  | { kind: "invalidClassDocument"; preferences: Preference[] }
  | { kind: "studentIneligible"; preferences: Preference[] }
